/* eslint-disable react-hooks/exhaustive-deps */
import OnlyHeader from "components/Layout/OnlyHeader";
import { useEffect, useRef, useState } from "react";
import moment from "moment";
import { DateRangePicker } from "react-date-range";
import { addDays } from "date-fns";
import {
  Card,
  CardHeader,
  CardFooter,
  Container,
  Row,
  Button,
  Input,
  Col,
  Spinner,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { getAllMerchantAction } from "store/actions/restaurantAction";
import {
  getfilterOrdersAction,
  getTotalAmount,
} from "store/actions/orderActions";
import exportFromJSON from "export-from-json";
import PaginationComponent from "components/shared/Pagination";
import TableComponent from "components/shared/Table";

function PaymentsAndReports() {
  const ref = useRef(null);
  const dispatch = useDispatch();
  const { allOrder, OrdersRestData, Loader, totalAmount } = useSelector(
    (state) => state.orders
  );
  const [isOpen, setIsOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [searchMerchant, setSearchMerchant] = useState("");
  const { merchantData } = useSelector((state) => state.restaurant);
  const [datestate, setDateState] = useState([
    {
      startDate: addDays(new Date(), -7),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const dateRangeString =
    datestate?.length > 0
      ? `${moment(datestate[0].startDate).format("DD MMM YYYY")} - ${moment(
          datestate[0].endDate
        ).format("DD MMM YYYY")}`
      : `${moment().format("DD MMM YYYY")} - ${moment().format("DD MMM YYYY")}`;
  const startDate = moment(datestate[0].startDate).unix();
  const endDate = moment(datestate[0].endDate).unix();

  const totalquantity = (order) => {
    const totalQuantity = order?.reduce((acc, item) => {
      return acc + item?.quantity;
    }, 0);
    return totalQuantity;
  };
  const handlePageChange = (event) => {
    setPageSize(event.target.value);
    setCurrentPage(0);
  };
  const totalAmountShow = () => {
    return totalAmount;
  };

  const exportData = () => {
    const fileName = "order detail";

    const exportType = exportFromJSON.types.csv;
    let temp = [];
    allOrder?.forEach((el) => {
      let qty = totalquantity(el?.order);
      temp.push({
        orderID: el?.id,
        "Items Sold": qty,
        "Total Amount": el?.totalAmount,
      });
    });
    if (temp?.length > 0) {
      exportFromJSON({ data: temp, fileName, exportType });
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);

  useEffect(() => {
    if (merchantData?.length > 0) {
      setSearchMerchant(merchantData[0]?.id);
    }
  }, [merchantData]);

  useEffect(() => {
    dispatch(getAllMerchantAction());
  }, []);

  useEffect(() => {
    if (searchMerchant) {
      dispatch(
        getfilterOrdersAction(
          searchMerchant,
          pageSize,
          currentPage,
          startDate,
          endDate
        )
      );
      dispatch(getTotalAmount(searchMerchant, startDate, endDate));
    }
  }, [searchMerchant, currentPage, pageSize, startDate, endDate]);

  return (
    <>
      <OnlyHeader />
      <Container className="mt--7 mb-5" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="">
                <Row className="justify-content-between  align-items-center">
                  <Col md="6">
                    <h3 className="mb-0 pt-2 d-block">Payments and Reports</h3>
                  </Col>
                  <Col md="6">
                    <h4 className="mb-0 pt-2 d-block">
                      Total Amount : {totalAmountShow()}$
                    </h4>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col xs="12" sm="6" md="6" xl="3" className="mt-2">
                    <Input
                      type="select"
                      id="exampleCustomSelect"
                      name="customSelect"
                      value={searchMerchant}
                      onChange={(e) => {
                        setSearchMerchant(e.target.value);
                      }}
                    >
                      <option value="" disabled>
                        Select Merchant
                      </option>
                      {merchantData?.map((obj) => (
                        <>
                          <option value={obj?.id}>
                            {obj?.name || obj?.email}
                          </option>
                        </>
                      ))}
                    </Input>
                  </Col>
                  <Col xs="12" sm="6" md="6" xl="3" className="mt-2">
                    <Input
                      type="select"
                      id="exampleCustomSelect"
                      name="customSelect"
                      value={pageSize}
                      onChange={handlePageChange}
                    >
                      <option value="5">Show Entries</option>
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                    </Input>
                  </Col>
                  <Col xs="12" sm="6" md="6" xl="3" className="mt-2">
                    <div ref={ref}>
                      <Input
                        value={dateRangeString}
                        className="pointer"
                        onClick={() => setIsOpen(!isOpen)}
                        readOnly
                      />
                      {isOpen && (
                        <DateRangePicker
                          onChange={(item) => setDateState([item.selection])}
                          showSelectionPreview={true}
                          moveRangeOnFirstSelection={false}
                          months={2}
                          ranges={datestate}
                          direction="horizontal"
                          preventSnapRefocus={true}
                          calendarFocus="backwards"
                          className="dateRangerSet"
                        />
                      )}
                    </div>
                  </Col>
                  <Col xs="12" sm="6" md="6" xl="3" className="mt-2">
                    <Button color="primary" block onClick={exportData}>
                      Export
                    </Button>
                  </Col>
                </Row>
              </CardHeader>
              {Loader ? (
                <div
                  className="loader d-flex justify-content-center align-items-center my-5"
                  style={{
                    overflow: "hidden",
                  }}
                >
                  <Spinner size="lg" color="primary" />
                </div>
              ) : (
                <>
                  <TableComponent
                    className="align-items-center table-flush"
                    responsive
                  >
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">Purchase Id</th>
                        <th scope="col">Date</th>
                        <th scope="col">Payment Method</th>
                        <th scope="col">Items sold</th>
                        <th scope="col">Total Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {allOrder?.length > 0 ? (
                        allOrder.map((el, idx) => {
                          const { _seconds, _nanoseconds } = el?.createdAt;
                          const timestampInMillis =
                            _seconds * 1000 +
                            Math.floor(_nanoseconds / 1000000);
                          const formattedDate =
                            moment(timestampInMillis).format("DD/MM/YYYY");
                          return (
                            <tr>
                              <td>{el?.id}</td>
                              <td>{formattedDate}</td>
                              <td>{el?.paymentMethod}</td>
                              <td>{totalquantity(el?.order)}</td>
                              <td>${el?.totalAmount}</td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={5} className="text-center py-5">
                            No Orders Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </TableComponent>
                </>
              )}
              <CardFooter className="py-4">
                <PaginationComponent
                  currentPage={currentPage}
                  totalPages={OrdersRestData?.nbPages || 0}
                  onPageChange={(page) => setCurrentPage(page)}
                />
              </CardFooter>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
}

export default PaymentsAndReports;
